import reducer from "./reducers";

import * as labtestOrderAction from "./actions";

export { labtestOrderAction };

export default reducer;
